import { Box, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import type { ILegalDependencyActionsProps } from '../../../Interfaces/ILegalDependency';
import { LegalDependencyActionRow } from './LegalDependencyActionRow';

export const LegalDependencyActions = ({
  actions,
  getRequirementOption,
  getStatusLabel,
  getTransactionOption,
  isLoadingLegalTransactions,
  isTransactionLoading,
  legalRequirementStates,
  onChangeAction,
  onRemoveAction,
  requirementOptionsByTransaction,
  transactionOptions,
}: ILegalDependencyActionsProps) => (
  <Card variant='outlined' sx={{ height: '100%', borderRadius: 3 }}>
    <CardContent sx={{ p: 2.5 }}>
      <Stack spacing={2.25}>
        <Box>
          <Stack alignItems='center' direction='row' spacing={1}>
            <Chip color='success' label='Dann' size='small' />
            <Typography variant='subtitle1'>Aktionen</Typography>
          </Stack>
          <Typography color='text.secondary' variant='body2'>
            Lege fest, welche Phase oder Maßnahme und welcher Zielstatus gesetzt
            werden sollen.
          </Typography>
        </Box>

        <Stack spacing={1.5}>
          {actions.map(action => {
            const requirementOptions =
              action.transactionId !== null
                ? requirementOptionsByTransaction.get(action.transactionId) ||
                  []
                : [];

            return (
              <Box key={action.id}>
                <LegalDependencyActionRow
                  action={action}
                  getRequirementOption={getRequirementOption}
                  getStatusLabel={getStatusLabel}
                  getTransactionOption={getTransactionOption}
                  isLoadingLegalTransactions={isLoadingLegalTransactions}
                  legalRequirementStates={legalRequirementStates}
                  onChange={updates => onChangeAction(action.id, updates)}
                  onRemove={() => onRemoveAction(action.id)}
                  removeDisabled={actions.length === 1}
                  requirementOptions={requirementOptions}
                  transactionLoading={isTransactionLoading(
                    action.transactionId
                  )}
                  transactionOptions={transactionOptions}
                />
              </Box>
            );
          })}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
